var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Picto"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7,
    cy: 7.5,
    r: 6.4,
    stroke: "white",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76792 6.43949C8.96318 6.24423 8.96318 5.92765 8.76792 5.73238C8.57266 5.53712 8.25607 5.53712 8.06081 5.73238L7.00039 6.7928L5.93998 5.73238C5.74471 5.53712 5.42813 5.53712 5.23287 5.73238C5.03761 5.92765 5.03761 6.24423 5.23287 6.43949L6.29329 7.49991L5.23238 8.56081C5.03712 8.75607 5.03712 9.07266 5.23238 9.26792C5.42765 9.46318 5.74423 9.46318 5.93949 9.26792L7.00039 8.20702L8.0613 9.26792C8.25656 9.46318 8.57314 9.46318 8.7684 9.26792C8.96367 9.07266 8.96367 8.75607 8.7684 8.56081L7.7075 7.49991L8.76792 6.43949Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.227a4badd627ec777d355af323aede4e.svg";
export { ForwardRef as ReactComponent };